import { useContent } from '@wix/funnel-builder-lizard'
import { ChevronLeft } from '@wix/wix-ui-icons-common/lazy'
import React, { FC } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { ErrorNotificationOutlet } from '../../../components/ErrorNotification/ErrorNotificationOutlet'
import Logo from '../logo.svg'
import s from './MobileBlock.scss'

export type Content = {
  title: string
  subtitle: string
  url?: string
  urlText?: string
}

export const HarmonyMobileBlock: FC = () => {
  const { content } = useContent<Content>()
  const pageLogger = usePageLogger()

  const handleBack = () => {
    pageLogger.back()
    window.history.back()
  }

  return (
    <div className={s.MobileBlock}>
      <header className={s.MobileBlock__header}>
        <button className={s.MobileBlock__backBtn} onClick={handleBack}>
          <ChevronLeft />
        </button>
        <hr className={s.MobileBlock__divider} />
        <Logo />
      </header>
      <ErrorNotificationOutlet />
      <div className={s.MobileBlock__content}>
        <span className={s.MobileBlock__title}>{content.title}</span>
        <span className={s.MobileBlock__subtitle}>{content.subtitle}</span>
        {content.urlText && content.url && (
          <a href={content.url} target="_blank" className={s.MobileBlock__link} rel="noreferrer">
            {content.urlText}
          </a>
        )}
      </div>
      <span className={s.MobileBlock__bottomBlur} />
    </div>
  )
}
